"use strict";
import Vue from 'vue'
import './assets/css/font/style.css'
import './assets/css/assuraf.css'
import './assets/css/material_icon.css'
import './assets/css/bootstrap-material-design.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './plugins/vuetify'
import Toasted from 'vue-toasted'
import router from './router'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import store from './store/store'
//import VeeValidate from "vee-validate"
import MarqueeText from 'vue-marquee-text-component' //vue-marquee-text-component
import money from 'v-money'
//import VueCrontab from 'vue-crontab'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'

import EN from './locales/en.json'
import FR from './locales/fr.json'

import VueI18n from 'vue-i18n';
// Force reload i18n - 2026-03-25
//importation de vue-meta pour la SEO et meta-tags
import Meta from 'vue-meta'

//importation de VueSocialSharing
import VueSocialSharing from 'vue-social-sharing'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueBrowserUpdate from "vue-browserupdate";  //Importation du plugin pour les anciens navigateurs
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import responsive from 'vue-responsive'


Vue.use(VueI18n);
const normalizeLocale = (locale) => {
  if (!locale) return 'FR'

  const normalized = String(locale).trim().toUpperCase()

  if (normalized.startsWith('FR')) return 'FR'
  if (normalized.startsWith('EN')) return 'EN'

  return 'FR'
}

// Forcer FR par défaut si sessionStorage est vide ou invalide
const storedLocale = sessionStorage.getItem('locale')
const initialLocale = storedLocale && (storedLocale === 'FR' || storedLocale === 'EN')
  ? normalizeLocale(storedLocale)
  : 'FR'
const messages = {
    EN: EN,
    FR: FR,
    en: EN,
    fr: FR
  };

  /* eslint-disable no-console */
  // DEBUG: Vérifier que les traductions sont chargées
  console.log('=== MAIN.JS i18n INIT ===');
  console.log('Initial Locale:', initialLocale);
  console.log('SessionStorage locale:', sessionStorage.getItem('locale'));
  console.log('FR.portefeuille exists:', !!FR.portefeuille);
  console.log('FR.portefeuille.vehicles_subtitle:', FR.portefeuille && FR.portefeuille.vehicles_subtitle);
  console.log('EN.portefeuille.vehicles_subtitle:', EN.portefeuille && EN.portefeuille.vehicles_subtitle);
  console.log('=========================');
  /* eslint-enable no-console */

  const i18n = new VueI18n({
    //locale: lang,
    locale: initialLocale,
    messages
  });

sessionStorage.setItem('locale', initialLocale)

Vue.use(responsive)
Vue.use( VueSplide );
Vue.use(VueBrowserUpdate, {
    options:{
        reminder: 5, //après combien d'heures le message doit-il réapparaître
        test: false,   //false à default, mettre true pour tester
        //text:"Pour naviguer sur notre site de maniere optimale, veuillez mettre {brow_name} à jour: <a{up_but}>Mettre a jour </a> ou <a{ignore_but}>ignorer</a>."
    }
}); //Utilisation du plugin VueBrowserUpdate

Vue.use(DatePicker);
Vue.use(VueTimepicker)

//utilisation de VueSocialSharing
Vue.use(VueSocialSharing);

//utilisation de vue-meta
Vue.use(Meta)

//Vue.use(VueCrontab);
Vue.use(money);
//Vue.use(VuePlyr);
Vue.component('marquee-text', MarqueeText);
Vue.use(Toasted);
//const options = { name: '_.' }; // customize the way you want to call it
//Vue.use(VeeValidate);

/*================================================*/
Vue.prototype.$dataLayer = []
Vue.prototype.$quoteCreationEntryPoint = {}
Vue.prototype.$loginPopupPosition = {}
Vue.prototype.$contactUsEntryPoint = {}

Vue.config.productionTip = true;
Vue.config.silent = true;  // ecrit les logs
Vue.config.performance = true; // active le module perf
Vue.config.devtools = true; // desactive le devtools des navigateurs

// Vue.config.errorHandler = (error, instance, info) => {
//   console.log("error emit : ", error)
//   console.log("instance emit : ", instance)
//   console.log("info on instance : ", info)
// }

sync(store, router);


new Vue({
    router,
    store,
    i18n,
    Toasted,
    render: h => h(App),
}).$mount('#app');

// router.beforeEach((to, from, next) => {
//   if(to.path=='/devis/auto' && store.state.country!=null)
//   {
//     switch (store.state.country) {
//       case "Senegal":
//         next()
//       break;
    
//       case "Cote d'ivoire":
//         router.push('/devis/auto/ci')
//       break;
//     }
//   }else{
//     next()
//   }
// })
